import Swal from 'sweetalert2';

export const updateObject = (currentObject, updatedProperties) => {
    return {
        ...currentObject,
        ...updatedProperties,
    };
};

export const updateArray = (currentArray, updatedProperties) => {
    return [...currentArray, updatedProperties];
};

export const uuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};


export const setFilterAnd = (params, key, value) => {
    if (params.filterAnd) {
        const filters = params.filterAnd.split(',');
        if (filters.indexOf(`${key}:${value}`) == -1) {
            filters.push(`${key}:${value}`);
            params.filterAnd = filters.join(',');
        }
    } else {
        params.filterAnd = `${key}:${value}`;
    }
    return params;
}

export const handleResponse = (response, onSuccess, onError = err => { }) => {
    if (onSuccess) {
        response.then(onSuccess).catch(onError);
    }
    return response;
}

export const handlerFormError = (data) => {
    const [key] = Object.keys(data|| '');
    if(key != 'status'){
        const message = data[key];
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message
        });
    }else{
        const message = data['message'];
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message
        });
    }
}

export const sizeOfArray = function (array) {

    let size = 0;

    for (let key in array) {
        if (array.hasOwnProperty(key)) {
            size++;
        }
    }

    return size;
}

export const getMultipartOptions = axios => {
    const headers = axios.defaults.headers;
    return { headers: { ...headers, 'Content-Type': 'multipart/form-data' } };
}

export const isValidUrl = (url) => {
    try {
        new URL(url);
    } catch (e) {
        console.error(e);
        return false;
    }
    return true;
};

export const upperFirstLetter  = (str) => {
    const arr = str.toLowerCase().split(" ");
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ");
}

export const cleanString = (str) => {
    return str.replace(/[^a-zA-Z0-9 ]/g, "")
}

export const formatDate = (date) => {
    var d = new Date(date),
        month = (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();


    if (month.length < 2) 
        month = '0' + month;

    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export const formatDateString = (date) => {
    if (!(date instanceof Date)) {
        //throw new Error('Invalid "date" argument. You must pass a date instance')
    }

    const name = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const d = new Date(date);
    const year = d.getFullYear();
    const month = name[d.getMonth()]; //String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    // var d = new Date(date),
    //     month = name[d.getMonth()],
    //     day = '' + d.getDate(),
    //     year = d.getFullYear();

    // if (day.length < 2) 
    //     day = '0' + day;

    return [day, month, year].join(' ');
}

export const isEmpty = (obj) => {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

export const truncate = ( str, max, sep ) => {

    // Default to 10 characters
    max = max || 10;

    var len = str.length;
    if(len > max){

        // Default to elipsis
        sep = sep || "...";

        var seplen = sep.length;

        // If seperator is larger than character limit,
        // well then we don't want to just show the seperator,
        // so just show right hand side of the string.
        if(seplen > max) {
            return str.substr(len - max);
        }

        // Half the difference between max and string length.
        // Multiply negative because small minus big.
        // Must account for length of separator too.
        var n = -0.5 * (max - len - seplen);

        // This gives us the centerline.
        var center = len/2;

        var front = str.substr(0, center - n);
        var back = str.substr(len - center + n); // without second arg, will automatically go to end of line.

        return front + sep + back;

    }

    return str;
}